import { render, staticRenderFns } from "./TraerNombre.vue?vue&type=template&id=630a55bd&"
import script from "./TraerNombre.vue?vue&type=script&lang=js&"
export * from "./TraerNombre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports